<template>
  <div class="supplierTable">
    <div class="topBar">
      <div>
        <el-input
          v-model="keyword"
          clearable
          placeholder="请输入物业单位名称进行查询"
          size="small"
          style="width: 300px; margin-right: 10px"
          @clear="search"
          @keydown.native.enter="search"
        ></el-input>
        <el-button size="small" type="primary" @click="search">查询</el-button>
      </div>
      <div>
        <el-button size="small" type="primary" @click="add"
          >添加物业单位</el-button
        >
      </div>
    </div>
    <div style="height: 60px"></div>
    <el-table :data="data" style="width: 100%" height="calc(100vh - 200px)">
      <el-table-column
        label="物业单位编号"
        prop="PMC_Code"
        width="200"
        sortable
      >
      </el-table-column>
      <el-table-column
        label="物业单位名称"
        prop="PMC_Name"
        align="left"
        sortable
      ></el-table-column>
      <el-table-column
        label="联系人"
        prop="PMC_Person"
        align="left"
        sortable
      ></el-table-column>
      <el-table-column
        label="手机号"
        prop="PMC_Phone"
        align="left"
        sortable
      ></el-table-column>
      <!-- <el-table-column label="备注" prop="Remarks"></el-table-column> -->
      <el-table-column align="center" label="操作" prop="action" width="100">
        <template slot-scope="scope">
          <el-button type="text" @click="edit(scope.row)">编辑</el-button>
          <el-button
            type="text"
            v-if="!scope.row.IsRegister"
            @click="del(scope.row.Id)"
            >删除</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <div style="text-align: right">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pagination.PageIndex"
        :page-sizes="pagination.PageSizes"
        :page-size="pagination.PageRows"
        layout="total, sizes, prev, pager, next, jumper"
        :total="pagination.total"
      >
      </el-pagination>
    </div>
    <PMCForm ref="pmcform" @comfirm="PMCFormComfirm" />
  </div>
</template>
<script>
const reg = /^1[345789]\d{9}$/
import QRCode from 'qrcodejs2'
import { mapState } from 'vuex'
import PMCForm from './PMCForm.vue'

export default {
  components: {
    PMCForm,
  },
  data() {
    return {
      data: [],
      inviteUrl: '', // 邀请链接
      allArr: [], // 查询前数据
      keyword: '',
      dialogVisible: false,
      invitePhone: '',
      invitePhoneVisible: false,
      pagination: {
        PageIndex: 1,
        PageRows: 20,
        PageSizes: [20, 40, 60, 100],
        total: 0,
      },
    }
  },
  mounted() {
    this.getDataList()
    this.inviteUrl =
      location.href.split('M')[0] + 'NoT/invite?UserId=' + this.userInfo.Id
  },
  computed: {
    ...mapState(['userInfo']),
  },
  methods: {
    handleCurrentChange(PageIndex) {
      this.pagination.PageIndex = PageIndex
      this.getDataList()
    },
    handleSizeChange(PageRows) {
      this.pagination.PageIndex = 1
      this.pagination.PageRows = PageRows
      this.getDataList()
    },

    async PMCFormComfirm() {
      await this.getDataList()
    },
    add() {
      this.$refs.pmcform.open({}, '添加物业单位')
    },
    // 编辑
    edit(obj) {
      this.$refs.pmcform.open(obj, '编辑物业单位')
    },
    // 删除
    del(Id) {
      this.$confirm('此操作将删除该物业单位, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          this.$http
            .post('/Base_BasicData/Base_PMC/DeleteData', [Id])
            .then(async (res) => {
              console.log(res)
              if (res.Success) {
                await this.getDataList()
                this.search()
              } else this.$notify.error(res.Msg)
            })
        })
        .catch(() => {})
    },
    // 邀请

    // 列表查询
    search() {
      this.pagination.PageIndex = 1
      this.getDataList()
    },
    // 数据源
    async getDataList() {
      await this.$http
        .post('/Base_BasicData/Base_PMC/GetDataList', {
          PageIndex: this.pagination.PageIndex,
          PageRows: this.pagination.PageRows,

          SortField: 'Id',
          SortType: 'asc',

          Search: {
            Condition: 'PMC_Name',
            Keyword: this.keyword,
          },
        })
        .then((res) => {
          if (res.Success) {
            this.data = res.Data
            this.pagination.total = res.Total
          }
        })
    },
    // 创建邀请二维码
    creatQrCode() {
      var qrcode = new QRCode(this.$refs.qrCodeUrl, {
        text: this.inviteUrl, // 需要转换为二维码的内容
        width: 150,
        height: 150,
        colorDark: '#000000',
        colorLight: '#ffffff',
        correctLevel: QRCode.CorrectLevel.H,
      })
    },
  },
}
</script>
<style lang="scss" scoped>
::v-deep .el-avatar img {
  display: block;
  height: 100%;
  width: 100%;
  vertical-align: middle;
}

::v-deep .el-table .el-table__cell {
  padding: 12px 0 !important;
}

.supplierTable {
  width: 100%;
  padding: 10px;
  border-right: 1px solid #ccc;
  border-left: 1px solid #ccc;
  height: 100%;
  padding-top: 30px;
  box-sizing: border-box;
  overflow-y: scroll;

  &::-webkit-scrollbar {
    height: 4px;
    width: 4px;
  }

  &::-webkit-scrollbar-thumb {
    /* 滚动条里面小方块 */
    border-radius: 10px;
    -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
    background: #e0e0e0;
  }

  &::-webkit-scrollbar-track {
    /* 滚动条里面轨道 */
    // -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
    // border-radius: 10px;
    background: transparent;
  }

  .topBar {
    position: fixed;
    width: 100%;
    height: 60px;
    left: 0px;
    top: 61px;
    z-index: 999;
    display: flex;
    padding: 0 10px;
    background: #ebeef5;
    box-sizing: border-box;
    align-items: center;
    justify-content: space-between;
  }

  .invite {
    display: flex;
    align-items: center;
    justify-content: space-evenly;

    div {
      text-align: left;
    }

    .line {
      width: 1px;
      height: 100%;

      div {
        height: 100px;
        width: 1px;
        background: #ccc;
        margin: 0 auto;
      }
    }
  }
}
</style>
